import { defineComponent as c, inject as p, computed as d, createElementBlock as u, openBlock as w, mergeProps as x, renderSlot as C } from "vue";
import { tw as t } from "../../utils/tailwind.js";
import { listVariantInjectionKey as h } from "../List/List.constant.js";
const y = /* @__PURE__ */ c({
  name: "RevListItemBase",
  inheritAttrs: !1,
  __name: "ListItemBase",
  props: {
    wrapperAttrs: { default: () => ({}) },
    itemsCenter: { type: Boolean, default: !1 }
  },
  setup(s) {
    const a = p(h, null), l = d(() => [
      /**
       * overflow-clip is a new value for the `overflow` property that behaves like `hidden`
       * but does not create a new block formatting context.
       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#clip
       *
       * It also fixes the issue of `text-overflow: ellipsis` not working when the element
       * is not a block formatting context.
       * @see https://github.com/BackMarket/design-system-vue2/blame/caa1c06a2ebeeddbb4dfa79a5d0a92242f3a8def/src/components/List/ListItem/ListItem.vue#L344
       *
       * @note `clip` is supported in Chrome>90, FF>91, Safari>16
       */
      // ESLint rule incorrectly flagging overflow-clip. I meant to use `overflow`
      // and not `text-overflow`.
      // eslint-disable-next-line tailwindcss/migration-from-tailwind-2
      t`overflow-clip supports-[not(overflow:clip)]:overflow-hidden`,
      t`bg-static-default-min text-static-default-hi body-2 flex w-full border-0 text-left no-underline duration-200 motion-safe:transition`,
      s.itemsCenter ? t`items-center` : t`items-start`,
      a?.value === "compact" ? t`py-8` : t`py-20`
    ]), r = [t`mr-8`], o = [t`body-1 w-full max-w-full`], i = [t`text-static-default-low w-full max-w-full`], n = [t`text-static-default-low ml-24 text-right`], m = [t`flex grow flex-col items-start`], f = [
      t`text-static-default-mid text-caption leading-caption`
    ];
    return (e, N) => (w(), u("li", x(e.wrapperAttrs, { class: "border-static-default-low relative list-none tap-highlight-transparent first:rounded-t-inherit last:rounded-b-inherit" }), [
      C(e.$slots, "default", {
        descriptionClassNames: i,
        labelClassNames: o,
        mainAreaClassNames: m,
        prefixClassNames: r,
        suffixClassNames: n,
        titleClassNames: f,
        wrapperClassNames: l.value
      })
    ], 16));
  }
});
export {
  y as default
};
